import { Component, Input, OnInit, ViewChild, EventEmitter, Output, ElementRef, Renderer, HostListener } from '@angular/core';
import { takealook, infopagepanel, delayfade, infodescription, panelVideo } from '../app.animations';
import { DomSanitizer, SafeResourceUrl, SafeUrl} from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MnFullpageService, MnFullpageOptions } from 'ngx-fullpage';

declare var $: any;

@Component({
  selector: 'app-info',
  templateUrl: './info.component.html',
  animations: [ takealook, infopagepanel, delayfade, infodescription, panelVideo ]
})


// Info Component
export class InfoComponent {

  @ViewChild('scene') scene;
  @ViewChild('Top') Top;

  // Sections
  @ViewChild('World') World;
  @ViewChild('Jobs') Jobs;
  @ViewChild('Home') Home;
  @ViewChild('Crime') Crime;
  @ViewChild('Empire') Empire;
  @ViewChild('Bottom') Bottom;
  @ViewChild('MainVideo') MainVideo: ElementRef;

  images: any;
  header: any;
  sections: any;
  title: string;
  showVideo = [];
  listings: [any];
  headerAlign: any;
  subtitle: string;
  backgrounds: any;
  headerHeight: any;
  scrollState:  any;
  lastOffset: number;
  showIntro: boolean;
  ShowLightbox: boolean;

  lastSection = 0;
  showImage = 0;
  viewingSection = 0;
  viewedSections = 0;
  ShowHeading = false;
  ShowDesc = false;
  scrollDownLink = false;
  showScrollLink = true;

  // background position
  bgX = 0;
  bgY = 0;
  bgPos = '';

  /* Mouse Movements */
  @HostListener('mousemove', ['$event'])
    onMousemove(event: MouseEvent) {
    this.bgX   = -(event.clientX/10);
    this.bgY   = -(event.clientY/10);
    this.bgPos = this.bgX+'px '+this.bgY+'px';
  }

  constructor(public renderer: Renderer,
              private sanitizer : DomSanitizer,
              public fullpageService: MnFullpageService ) { 
    
    this.images = [{
      url: "/assets/img/info-world.jpg",
      thumb: "/assets/img/info-world.jpg",
      caption: "Map of the Identity world"
    },{
      url: "/assets/img/info-jobs.jpg",
      thumb: "/assets/img/info-jobs.jpg",
      caption: "Police SWAT entry"
    },{
      url: "/assets/img/info-home.jpg",
      thumb: "/assets/img/info-home.jpg",
      caption: "Player housing and real estate"
    },{
      url: "/assets/img/info-crime.jpg",
      thumb: "/assets/img/info-crime.jpg",
      caption: "Live a life of crime"
    },{
      url: "/assets/img/info-business.jpg",
      thumb: "/assets/img/info-business.jpg",
      caption: "Player-owned businesses"
    }];
    
    this.listings = [{ images: [] }];
    this.listings[0].images = this.images;
  
  }

  @HostListener('window:keyup', ['$event'])
  keyEvent(event: KeyboardEvent) {
    
    if ( event.code == 'Space' ) {
      this.nextSection();
    }

    if ( event.code == 'ArrowDown' ) {
      this.nextSection();
    }

    if ( event.code == 'ArrowUp' ) {
      this.prevSection();
    }

  }


  // trigger a light box
  view(i) {
    this.ShowLightbox = true;
    this.showImage = i;
    return;
  }

  inSight(element) {
    let elemTop = element.getBoundingClientRect().top;
    var elemBottom = element.getBoundingClientRect().bottom;
    var isVisible = (elemTop >= 0) && (elemBottom <= window.innerHeight);
    return isVisible;
  }

  whatSection() {
    
    let topOffset = 0;

    for (var i = 0; i <= this.sections.length-1; i++) {
      
      topOffset = this.sections[i].nativeElement.offsetTop;

      if ( window.pageYOffset >= (topOffset-10)  ) {
        this.viewingSection = i;
      }

      if ( window.pageYOffset >= (topOffset-window.screen.height) && i > this.viewedSections ) {
        this.viewedSections = i;
      }

    }

    return this.viewingSection;
  }

  goToSection(set?) {
    this.viewingSection = set;
    this.sections[set].nativeElement.offsetTop;
    let y = this.sections[set].nativeElement.offsetTop;
    this.scrollTo( y );
  }

  nextSection() {
    this.whatSection();
    this.goToSection(this.viewingSection + 1);
  }


  prevSection() {
    this.whatSection();
    this.goToSection(this.viewingSection - 1);
  }

  ngOnDestroy() {
     $('.scene').css('background',this.backgrounds[0]);
  }


  @Input() public options: MnFullpageOptions = new MnFullpageOptions({
    navigation: true,
    keyboardScrolling: true
  });


  @HostListener('window:scroll', ['$event'])
    public onWindowScroll(event: Event): void {
      
     
      event.preventDefault();
      this.showScrollLink = false;

      if ( this.lastOffset != window.scrollY ) {
        this.lastOffset = window.scrollY;
      }

      this.whatSection();

  }

  scrollTo(numb) { $('html, body').animate({ scrollTop: numb }, 500); }
  goToTop() { this.viewedSections = 0; this.scrollTo( 0 ); }

  /* On with the show */
  ngOnInit() {

    this.headerHeight = '100vh';
    this.subtitle = 'Changing what it means to be an MMORPG';
    this.header = this.sanitizer.bypassSecurityTrustStyle( 'url("/assets/img/concept/Final3.jpg") 0px 73%' );

    // Define Sections and Background Styles
    this.sections = [ this.Top, this.World, this.Jobs, this.Home, this.Crime, this.Empire, this.Bottom ];
    this.backgrounds = ['#000', '#1a1b2f','#3a0000','#044684','#351e09','#1c1c1d','#000000'];

    setTimeout( () => { this.ShowHeading = true; }, 100 );
    setTimeout( () => { this.scrollDownLink = true; }, 3000 );
    setTimeout( () => { this.ShowDesc = true; }, 20500 );
    setTimeout( () => { this.showIntro = true; }, 3000 );

    // Set the scene
    this.whatSection();
    $('.scene').css('background',this.backgrounds[0]);

  }


}


// WEBPACK FOOTER //
// C:/Users/Asylum/identity-vagrant/src/asylum-idenetity/src/app/info/info.component.ts